class Particle {
  constructor(canvas, options = {}) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.particles = [];
    this.options = {
      particleCount: options.particleCount || 100,
      colors: options.colors || ['#ffffff', '#eeeeee', '#dddddd'],
      minSize: options.minSize || 1,
      maxSize: options.maxSize || 3,
      speed: options.speed || 0.5,
      connectParticles: options.connectParticles !== undefined ? options.connectParticles : true,
      lineColor: options.lineColor || 'rgba(255, 255, 255, 0.15)',
      lineWidth: options.lineWidth || 1
    };
    
    this.init();
  }
  
  init() {
    // Set canvas size
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
    
    // Create particles
    for (let i = 0; i < this.options.particleCount; i++) {
      this.particles.push({
        x: Math.random() * this.canvas.width,
        y: Math.random() * this.canvas.height,
        size: Math.random() * (this.options.maxSize - this.options.minSize) + this.options.minSize,
        color: this.options.colors[Math.floor(Math.random() * this.options.colors.length)],
        speedX: (Math.random() - 0.5) * this.options.speed,
        speedY: (Math.random() - 0.5) * this.options.speed
      });
    }
    
    // Start animation loop
    this.animate();
    
    // Handle resize
    window.addEventListener('resize', () => this.resize());
  }
  
  animate() {
    // Clear canvas
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    
    // Update and draw particles
    for (let i = 0; i < this.particles.length; i++) {
      let p = this.particles[i];
      
      // Move particle
      p.x += p.speedX;
      p.y += p.speedY;
      
      // Wrap around screen
      if (p.x > this.canvas.width) p.x = 0;
      if (p.x < 0) p.x = this.canvas.width;
      if (p.y > this.canvas.height) p.y = 0;
      if (p.y < 0) p.y = this.canvas.height;
      
      // Draw particle
      this.ctx.beginPath();
      this.ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      this.ctx.fillStyle = p.color;
      this.ctx.fill();
      
      // Connect particles
      if (this.options.connectParticles) {
        for (let j = i + 1; j < this.particles.length; j++) {
          let p2 = this.particles[j];
          let distance = Math.sqrt(
            Math.pow(p.x - p2.x, 2) + 
            Math.pow(p.y - p2.y, 2)
          );
          
          if (distance < 120) {
            this.ctx.beginPath();
            this.ctx.strokeStyle = this.options.lineColor;
            this.ctx.lineWidth = this.options.lineWidth;
            this.ctx.moveTo(p.x, p.y);
            this.ctx.lineTo(p2.x, p2.y);
            this.ctx.stroke();
          }
        }
      }
    }
    
    requestAnimationFrame(() => this.animate());
  }
  
  resize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  }
}

export default Particle; 